/* import __COLOCATED_TEMPLATE__ from './tippy.hbs'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from '@glimmer/component';
import { warn } from '@ember/debug';
import YieldTippyInstance from '../-private/yield-tippy-instance';
import TippyForComponentModifier from '../-private/tippy-for-component';
export default class TippyComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "yieldTippyInstance", new YieldTippyInstance());
    _defineProperty(this, "tippyModifier", TippyForComponentModifier);
  }
  get _options() {
    return this.args.options || this.args;
  }
  get options() {
    return {
      ...this._options,
      onInstancesCreate: this.onInstancesCreate.bind(this)
    };
  }
  onInstancesCreate(instances) {
    if (Array.isArray(instances)) {
      // Tippy himself should warn about it too:
      // > tippy() was passed an Element as the `content` prop, but more than one tippy instance
      // > was created by this invocation. This means the content element will only be appended
      // > to the last tippy instance.
      //
      // > Instead, pass the .innerHTML of the element, or use a function that returns a cloned
      // > version of the element instead.
      //
      // > 1) content: element.innerHTML
      // > 2) content: () => element.cloneNode(true)
      warn('"component:tippy" with "content: HTMLElement" does not support multiple tippies' + ` (target="${this.options.target}").`, instances.length === 1, {
        id: 'ember-tippy.component-content-htmlelement-multiple-tippies'
      });
      instances = instances[instances.length - 1];
    }
    this.yieldTippyInstance.tippyInstance = instances;
    this._options.onInstancesCreate?.(instances);
  }
}